import React, { useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LinearScale
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const IncomeChart = ({ earn, courses, backgroundColor, borderColor, price }) => {
    const dataSetTwoBgColor = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.25)`;
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Earnings and Course Price for each Course',
            },
        },
    };
    const labels = courses;
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    window.addEventListener('resize', function () {
        setScreenWidth(window.innerWidth);
    });
    const data = {
        labels,
        datasets: [
            {
                label: ' Total ₹',
                data: earn,
                backgroundColor: backgroundColor[0],
                borderColor: borderColor[0],
                borderWidth: 1,
            },
            {
                label: ' Course Price ₹',
                data: price,
                backgroundColor: dataSetTwoBgColor,
                borderColor: dataSetTwoBgColor.replace('0.2', '1'),
                borderWidth: 1,
            },
        ],
    };

    return (
        <Bar
            options={options}
            data={data}
            height={`${screenWidth < 768 && screenWidth > 450 ? '7vh' : screenWidth < 450 && '15vh'}`}
            width={`${screenWidth < 768 && '7vw'}`}
        />
    );
}

export default IncomeChart;